// src/analytics/analyticsService.ts
import * as amplitude from '@amplitude/analytics-browser';
import type { TrackingEvent, EventAttributes } from './trackingTypes';

/**
 * Tracks an event with optional attributes.
 * All events are prefixed with "Pocket Admin " via the TrackingEvent type.
 */
export function track(event: TrackingEvent, attributes?: EventAttributes): void {
  amplitude.track(event, attributes);
}

/**
 * Sets the user ID from the OIDC token's sid claim.
 */
export function setUserId(sessionId: string): void {
  amplitude.setUserId(sessionId);
}

/**
 * Resets the user identity on logout.
 */
export function resetIdentity(): void {
  amplitude.reset();
}

/**
 * Extracts the sid claim from an OIDC access token.
 * Returns null if extraction fails.
 */
export function extractSessionId(accessToken: string): string | null {
  try {
    const parts = accessToken.split('.');
    if (parts.length !== 3) return null;

    const payload = JSON.parse(atob(parts[1])) as Record<string, unknown>;
    const sid = payload.sid;

    return typeof sid === 'string' ? sid : null;
  } catch {
    return null;
  }
}
